import React from 'react';
import MultiselectWrapper from '../OMContainers/MultiselectWrapper/MultiselectWrapper';
import { formatProjectOptions } from '../../utils/formatSearchBoxData';
import { projectStatusesTitle } from '../../utils/multiselectsTitles';

const ProjectStatusDropdown = (properties) => {
  const { locale, translate, handleChange, className, width, selectedStatuses, onOpen } = properties;
  const statusInput = formatProjectOptions(locale, translate, 'isFullTitle');
  const statusesTitle = projectStatusesTitle(selectedStatuses, locale, translate, 'isFullTitle');

  return (
    <MultiselectWrapper
      multiSelectClassName={className}
      options={statusInput}
      title={statusesTitle}
      value={selectedStatuses}
      onChange={handleChange}
      width={width}
      onOpen={onOpen}
    />
  );
};

export default ProjectStatusDropdown;
